import { getProductHtml } from './home-product-module';
export function getFrontListHtml(frontList, frontListIndex) {
    let productsHtml = '';
    for (let i = 0; i < 6; i++) {
        const product =  frontList.productShortViews[i];
        let serial = 0;
        if (frontList.type === 'WEB_HOME_SPECIAL' || frontList.type === 'WEB_AND_APP_HOME_SPECIAL') {
            serial = frontList.productShortViews.length - i;
        }
        productsHtml += getProductHtml(product, serial, `sfl_d_${frontListIndex}_${i}` );
    }
    return `
        <section class="home-book-list-section ${frontList.type === 'WEB_HOME_SPECIAL' || frontList.type === 'WEB_AND_APP_HOME_SPECIAL' ? 'home-book-list--special' : ''}">
            <div class="row">
                <div class="col-8 d-flex align-items-center">
                    <h2 class="home-book-list-title">${frontList.title}</h2>
                </div>
                <div class="col-4">
                    <a href="${frontList.link}" class="btn btn-outline-secondary list-btn float-right">View All</a>
                </div>
            </div>
            <div class="rok-carousel" id="front-list-${frontList.id}" lgs-count="6" mds-count="5" sms-count="4">
                <button class="btn-prev disabled"></button>
                <div class="slide">${productsHtml}</div>
                <button class="btn-next"></button>
            </div>
        </section>
    `;
}
